fields:
  name: Bedrijfsnaam
  slug: Webadres publieke pagina
  firstName: Voornaam
  insertions: Tussenvoegsel (optioneel)
  lastName: Achternaam
  email: Emailadres
messages:
  backToLogin: Terug naar login
  companyDetails: Vul de gegevens van je bedrijf in
  adminUser: Deze gebruiker wordt automatisch beheerder
  pricePlan: Machtiging voor automatische incasso
  whatYouGet: Wat je krijgt met 4YourPlan
  emailHint: Op dit emailadres ontvang je belangrijke updates en je kunt hiermee inloggen.
  amountOfDaysForTrail: "{count} {period} gratis proberen|{count} {period} gratis proberen"
  activateAccountInstruction: Om jouw account veilig te activeren, betaal je eenmalig € 0,02 om de machtiging voor de automatische incasso af te geven.
  cancelAccountInFreeTrailInstruction: Zeg je binnen {count} {period} op? Dan wordt er gegarandeerd niets afgeschreven en stopt het abonnement aan het eind van jouw proefperiode.
  subscription:
    name: 4YourPlan Abonnement
    appointments: Onbeperkt aantal afspraken
    customerDetails: Volledige klantdossiers
    tenantWebsite: Publieke boekingspagina
    reminders: Email reminders voor klanten
  acceptAgreements: Ik ga akkoord met de {0} en {1} van 4YourPlan
  paymentFailedTitle: Machtiging mislukt
  paymentFailedDescription: "Geen zorgen, er is niets afgeschreven. Probeer het gerust nog een keer. Blijft het misgaan? Neem dan contact op via {0}, we helpen je graag verder."
  access:
    calendar:
      title: Volledige agendabeheer
      description: Plan afspraken, beheer medewerkers en behandelingen
    customer:
      title: Klantendossiers
      description: Bewaar notities, foto's en behandelhistorie
    tenantWebsite:
      title: Publieke boekingspagina
      description: Klanten kunnen 24/7 online afspraken maken
    email:
      title: Email reminders
      description: Automatische herinneringen naar klanten
stepperHeadings:
  companyDetails: Bedrijfsgegevens
  adminUser: Hoofdgebruiker
  pricePlan: Betaling instellen
labels:
  pricing: De eerste
  pricingAfter: Daarna
  cancelablePeriod: Maandelijks opzegbaar
  freeTrail: "{count} dag gratis|{count} dagen gratis"
  fullyAccessible: Volledige toegang
  tenantAdminUrl: Beheer omgeving
  per: per
  generalPolicy: algemene voorwaarden
  privacyPolicy: privacyverklaring
  support: support
actions:
  createPayment: Machtiging afgeven en proefperiode starten
success:
  title: Welkom bij 4YourPlan!
  description: "Je account is succesvol aangemaakt. Je kunt nu {count} {period} lang gratis alle functionaliteiten uitproberen.|Je account is succesvol aangemaakt. Je kunt nu {count} {period} lang gratis alle functionaliteiten uitproberen."
  company: Bedrijf
  urls: Jouw bedrijf URLs
  publicUrl: Publieke boekingspagina
  adminUrl: Beheer omgeving
  account: Account
  subscription: Abonnement
  billingCycle: maandelijks opzegbaar
  freeUntil: "Gratis tot {date}"
  autoActivateNotice: Je abonnement wordt automatisch geactiveerd na de proefperiode, tenzij je eerder opzegt.
  confirmationEmail: Je ontvangt een bevestigingsmail op {0} met je inloggegevens en verdere instructies.
  action: Naar inlogpagina
